// The templating layer a Section carries.
//
// A section stores two things side by side: `types`, which DECLARES the editable
// slots in its markup, and `values`, which holds what somebody put in them. The
// entry point is always the type named "root" — every consumer hard-codes that
// name, which is why the default below is `[{ name: "root", params: [] }]` and
// not an empty array.
//
// Nothing here describes the values themselves. `/Types/Value` is deliberately
// a free-form object: the real schema for it does not exist until runtime, when
// generateSchema (app/code/src/... via @repoflow/components/types-values)
// compiles the `types` array into one. That is the whole point of the system —
// the shape of a section's content is data, not code.
//
// Ported from the archived project's @repoflow/schema/types.
import * as Params from "./params";
import * as Form from "./form";
import UtilsSchema from "@repoflow/schema/utils";
import * as SchemaLib from "@repoflow/schema";

const schema = [
  ...UtilsSchema,
  ...Params.schema,
  ...Form.schema,
  {
    id: "/Types/Type",
    type: "object",
    required: ["name"],
    properties: {
      name: {
        label: "Name",
        $ref: "/Name/Required",
        minLength: 1,
        default: "",
      },
      description: {
        label: "Description",
        type: "string",
        textarea: true,
        default: "",
      },
      params: {
        label: "Params",
        type: "array",
        items: { $ref: "/Types/Param" },
        // Turns on drag-reorder in the list widget, which keys rows by this
        // property rather than by array position.
        index: "name",
        default: [],
      },
      form: { $ref: "/Types/Form", default: {} },
    },
  },
  {
    id: "/Types/Value",
    type: "object",
    properties: {},
    patternProperties: { "^.+$": {} },
  },
  {
    id: "/Input/Types",
    type: "object",
    properties: {
      types: {
        label: "",
        type: "array",
        items: { $ref: "/Types/Type" },
        default: [],
      },
    },
  },
];

export const defaultTypeValues = (name = "") => {
  const vals = SchemaLib.defaultValues(schema, { $ref: "/Types/Type" });
  vals.name = name;
  return vals;
};

export default schema;
